var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefused(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 28,
    viewBox: "0 0 27 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26.9189,
    height: 28,
    rx: 13.4595,
    fill: "#EF4444"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.94159 9.4783C9.66453 9.20124 9.21533 9.20124 8.93826 9.4783C8.6612 9.75536 8.6612 10.2046 8.93826 10.4816L12.4569 14.0002L8.93826 17.5188C8.6612 17.7959 8.6612 18.2451 8.93826 18.5222C9.21533 18.7992 9.66453 18.7992 9.94159 18.5222L13.4602 15.0036L16.9788 18.5222C17.2559 18.7992 17.7051 18.7992 17.9821 18.5222C18.2592 18.2451 18.2592 17.7959 17.9821 17.5188L14.4635 14.0002L17.9821 10.4816C18.2592 10.2046 18.2592 9.75536 17.9821 9.4783C17.7051 9.20124 17.2559 9.20124 16.9788 9.4783L13.4602 12.9969L9.94159 9.4783Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefused);
export default __webpack_public_path__ + "static/media/refused.51d94018509a337c8e248aaec58b99d5.svg";
export { ForwardRef as ReactComponent };